<template>
  <div class="d-flex">
    <b-button 
      v-if="canComentar"
      size="sm" 
      @click="onModalCommentValidacion()"
      style="position: relative;"
      title="Comentario Validacion"
    >
      <strong>
        <i class="fa-solid fa-check-to-slot" />
      </strong>

      <b-badge
        v-if="nRevisados"
        style="position: absolute; top: -0.5rem;"
        variant="danger"
      >
        {{ nRevisados }}
      </b-badge>

    </b-button>


    <b-button
      v-if="canViewComentarios"
      size="sm" 
      @click="onModalCommentValidacion()"
      style="position: relative;"
      title="Ver Comentarios"
      variant="warning"
    >
      <strong>
        <i class="fa-solid fa-check-to-slot" />
      </strong>

      <b-badge
        v-if="nPorRevisar"
        style="position: absolute; top: -0.5rem;"
        variant="danger"
      >
        {{ nPorRevisar }}
      </b-badge>

    </b-button>
  </div>
  
</template>

<script>
import { ROLES } from '@/shared/constants';
import { comprobarRoles } from '@/shared/helpers';
import { citasValidacionesService } from '../../services/citasValidacionesService';

export default {
  name: "ButtonComentariosValidacion",

  props: {
    tokenCita: String,
  },

  created() {
    this.onGetComentarios();
  },

  data() {
    return {
      nPorRevisar: 0,
      nRevisados: 0
    };
  },


  methods: {

    async onGetComentarios(){
      const responseComentarios = await citasValidacionesService.getComentariosValidacion(this.tokenCita);
      this.nPorRevisar = responseComentarios.filter( c => c.estadoComentario === '1' ).length;
      this.nRevisados = responseComentarios.filter( c => c.estadoComentario === '2' ).length;
    },

    onModalCommentValidacionView( ){
      this.$router.push({ name: 'atenciones-medicas', query: { vvalidator: this.tokenCita } });
    },

    onModalCommentValidacion(){
      this.navigateToQuery('validator', this.tokenCita);
    },


    navigateToQuery(queryParam, valueQuery) {
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            [queryParam]: valueQuery,
          },
        });
      } catch (error) {
        console.error("Error en la navegación:", error);
      }
    },
  },


  computed: {
    canViewComentarios(){
      return comprobarRoles([ROLES.ADMISION, ROLES.JEFE_MEDICO]);
    },
    
    canComentar(){
      return comprobarRoles([ROLES.JEFE_VALIDACIONES, ROLES.DIGITADOR]);
    }
  }
}
</script>
